module.exports = __webpack_public_path__ + "img/debtPayingAbility7.6f7e4bbd.png";